import { api } from "@utilities/api";
import { getCaptchaToken } from "@/app/_providers/hcaptcha/core";

interface UploadResponse {
  asset_id: string;
}

interface CreativeTemplateGenerateResponse {
  asset_id: string;
  success: boolean;
  model_id: string | null;
  refined_prompt: string | null;
}

interface SignedUrlResponse {
  url: string;
  file_name: string | null;
  content_type: string;
}

export async function uploadCreativeTemplateAsset(file: File, signal?: AbortSignal): Promise<UploadResponse> {
  const hcaptchaToken = await getCaptchaToken({ behaviourType: "creative_template" });

  const formData = new FormData();
  formData.append("file", file);
  formData.append("hcaptcha_token", hcaptchaToken);

  return api.post<UploadResponse>("/v1/creative-templates/anonymous/upload", formData, { signal });
}

export async function getCreativeTemplateSignedUrl(assetId: string, signal?: AbortSignal): Promise<SignedUrlResponse> {
  const hcaptchaToken = await getCaptchaToken({ behaviourType: "creative_template" });

  return api.post<SignedUrlResponse>(
    "/v1/creative-templates/anonymous/get-signed-url",
    {
      asset_id: assetId,
      hcaptcha_token: hcaptchaToken,
    },
    { signal },
  );
}

export async function generateCreativeTemplate({
  templateSlug,
  assetId,
  userInput,
  signal,
}: {
  templateSlug: string;
  assetId?: string;
  userInput?: string;
  signal?: AbortSignal;
}): Promise<CreativeTemplateGenerateResponse> {
  const hcaptchaToken = await getCaptchaToken({ behaviourType: "creative_template" });

  const body: Record<string, string | boolean> = {
    template_slug: templateSlug,
    hcaptcha_token: hcaptchaToken,
  };

  if (assetId) body.asset_id = assetId;
  if (userInput) body.user_input = userInput;

  return api.post<CreativeTemplateGenerateResponse>("/v1/creative-templates/anonymous/generate", body, { signal });
}
